export const PIXEL_ID = '3070568583125644'

// Declare fbq type for TypeScript
declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export const initPixel = () => {
  if (typeof window === 'undefined') return

  // Check if pixel is already loaded
  if (window.fbq) {
    console.log('Meta Pixel already initialized')
    return
  }

  // Initialize fbq stub
  const fbq: any = function () {
    fbq.callMethod
      ? fbq.callMethod.apply(fbq, arguments)
      : fbq.queue.push(arguments)
  }

  if (!window.fbq) window.fbq = fbq
  if (!window._fbq) window._fbq = fbq

  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []

  // Create and inject script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'

  // Append to head (more reliable than insertBefore)
  document.head.appendChild(script)

  // Initialize pixel with ID
  window.fbq('init', PIXEL_ID)

  console.log('Meta Pixel initialized:', PIXEL_ID)
}

export const trackEvent = (eventName: string, data?: any) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, data)
    console.log('Meta Pixel Event:', eventName, data)
  } else {
    console.log('Meta Pixel not loaded. Event:', eventName, data)
  }
}

// Track PageView specifically
export const trackPageView = () => {
  trackEvent('PageView')
}

// Track custom events
export const trackViewContent = (data?: any) => {
  trackEvent('ViewContent', data)
}

export const trackInitiateCheckout = (data?: any) => {
  trackEvent('InitiateCheckout', data)
}

export const trackPurchase = (value: number, currency: string = 'USD') => {
  trackEvent('Purchase', { value, currency })
}
